import { Sun, Moon } from 'lucide-react';
import { Link } from '@tanstack/react-router';
import { Mark } from './Mark';
import { SearchPill } from './SearchPill';
import { WorkspaceSelector } from './WorkspaceSelector';
import { UserChip } from './UserChip';
import { useTheme } from '@/lib/theme';
import { cn } from '@/lib/utils';

export function TopBar() {
  const { resolved, toggle } = useTheme();

  return (
    <header className="sticky top-0 z-30 grid h-16 items-center gap-3 border-b border-frame-edge bg-frame/95 px-4 backdrop-blur-md
      grid-cols-[auto_1fr_auto_auto] md:grid-cols-[auto_1fr_auto_auto_auto]">
      <Link to="/" className="shrink-0">
        <Mark />
      </Link>

      <div className="hidden md:flex justify-center min-w-0">
        <SearchPill />
      </div>

      <div className="hidden md:block">
        <WorkspaceSelector />
      </div>

      <button
        type="button"
        onClick={toggle}
        aria-label="Alternar tema"
        className={cn(
          'grid h-9 w-9 place-items-center rounded-full border border-card-stroke bg-frame text-fg',
          'shadow-1 transition-all duration-fast hover:bg-card-soft',
        )}
        title={resolved === 'dark' ? 'Tema claro' : 'Tema escuro'}
      >
        {resolved === 'dark' ? (
          <Sun className="h-4 w-4" strokeWidth={1.8} />
        ) : (
          <Moon className="h-4 w-4" strokeWidth={1.8} />
        )}
      </button>

      <UserChip />
    </header>
  );
}
